/**
 * @owner @Appboy/core-objects
 */

export const appSettingsGetCustomEventProperties = "/app_settings/get_custom_event_properties";
